import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { GlobalCSSClass as s } from "../../../utils/enums.js";
const a = "ids-clear-button--input-v501", l = "ids-clear-button--clear-v501", o = {
  input: a,
  clear: l
}, u = ({ onClick: e }) => /* @__PURE__ */ r(
  "button",
  {
    className: o.clear,
    onClick: e,
    onMouseDown: (n) => n.preventDefault(),
    children: [
      /* @__PURE__ */ t("span", { "aria-hidden": "true", children: "×" }),
      /* @__PURE__ */ t("span", { className: s.SROnly, children: "Clear" })
    ]
  }
);
export {
  u as ClearButton
};
